export default __webpack_public_path__ + "static/media/plus_green_bolt.b742b527.svg";